import type { Image as ImageType } from 'types/capi/shared';

import InformationIcon from '~/assets/icons/Information';
import NewMailIcon from '~/assets/icons/NewMail';
import Tracked from '~/components/Tracked';

import ExitNotificationDialog from './ExitNotificationDialog';

type Props = {
  email: string;
  image?: ImageType;
  onDismiss: () => void;
};

export default function ConfirmEmailReminder({
  email,
  image,
  onDismiss
}: Props) {
  return (
    <ExitNotificationDialog
      heading="One last thing!"
      image={image}
      onDismiss={onDismiss}
    >
      <div className="flex w-full flex-col items-center gap-2 rounded-2xl bg-grey-tile px-2 py-4">
        <div className="flex flex-col items-center gap-2">
          <NewMailIcon
            width="42"
            height="42"
            stroke="black"
            fill="none"
            circleStroke="black"
          />
          <span className="text-xs text-grey-hide">
            Confirmation sent to {email}
          </span>
        </div>
        <span className="text-base font-bold">
          Click the link in your inbox and you&apos;re all set up!
        </span>
        <div className="flex w-full items-center justify-center gap-2 rounded-lg bg-yellow-label p-2 text-center">
          <InformationIcon />
          <span className="text-xs font-semibold">
            You won&apos;t receive stock notifications until you confirm your
            email.
          </span>
        </div>
      </div>
      <Tracked.Button
        variant="forest"
        className="h-12 w-full"
        onClick={onDismiss}
        name="ILL_CHECK_MY_INBOX"
        pagePosition="Cancel modal"
      >
        I&apos;ll check my inbox
      </Tracked.Button>
    </ExitNotificationDialog>
  );
}
